import { Form, FormConfig, FormPage, FormQuestion } from "@ambii-com/core";
import {
  liteCollections,
  liteGetDocument,
  liteGetDocumentsIn,
  liteQueryCollection,
  liteQueryCollectionLimited,
} from "~/utils/firestoreLite";

export async function readForm(formId: string): Promise<Form> {
  return liteGetDocument(liteCollections.forms, formId).then(Form.fromDoc);
}

export async function readFormConfig(formConfigId: string): Promise<FormConfig> {
  return liteGetDocument(liteCollections.formConfigs, formConfigId).then(
    FormConfig.fromDoc
  );
}

export async function readFormConfigByShortLinkPath(
  shortLinkPath: string
): Promise<FormConfig | undefined> {
  const docs = await liteQueryCollectionLimited(
    liteCollections.formConfigs,
    1,
    ["shortLinkPath", "==", shortLinkPath]
  );
  if (docs.length === 0) {
    return undefined;
  }
  return FormConfig.fromDoc(docs[0]);
}

export async function readFormPages(pageIds: string[]): Promise<FormPage[]> {
  const docs = await liteGetDocumentsIn(liteCollections.formPages, pageIds);
  return FormPage.fromDocs(docs);
}

export async function readFormQuestion(
  questionId: string
): Promise<FormQuestion> {
  return liteGetDocument(liteCollections.formQuestions, questionId).then(
    FormQuestion.fromDoc
  );
}

export async function readFormsForClinic(clinicId: string): Promise<Form[]> {
  const docs = await liteQueryCollection(liteCollections.forms, "clinicId", clinicId);
  return Form.fromDocs(docs);
}
